import React from "react";
import { WizClassifySelectRe, WizAuthority, WizTableForm,WizDataAuthSelect } from '@/containers/common'
import { framework_tool, component_tool } from "@/tool";
import ContentText from "./components/contentText";
const { WizAvatarUpload } = framework_tool;
const {
  WizAntdForm,
  WizInput,
  WizRow,
  WizCol,
  WizDatePicker,
  WizRadio,
  WizCheckbox,
  Wizmessage
} = component_tool;


// 验证规则
const config = ({ type, label }) => {
  return {
    rules: [{
      required: true, message: `请${type !== "input" ? "选择" : "输入"}${
        label
        }`
    }]
  }
}

export const getFields = ({
  fields,
  withCol = false,
  colSpan = 24,
  onChangeRowMap,
  ...other
}, hiddenType) => {
  const { form, formItemLayout } = other;
  const { getFieldDecorator } = form;
  const children = [];
  let jsx, item, formFieldOptions;
  for (let i = 0; i < fields.length; i++) {
    switch (fields[i].type) {
      case "date":
        jsx = <WizDatePicker style={{ width: "100%" }} showTime />;
        break;
      case "upload":
        jsx = <AvatarUpload />
        break;
      case "textArea":
        jsx = (
          <WizInput.TextArea
            rows={2}
            maxLength={50}
            placeholder={`请输入${fields[i].label},最多输入50个字`}
          />
        );
        break;
      case "hidden":
        jsx = <React.Fragment></React.Fragment>;
        break;
      case "checkbox":
        jsx = <WizCheckbox.Group options={fields[i].fields} />;
        break;
      case "radio":
        jsx = <WizRadio.Group options={fields[i].fields} />
        break;
      case "diy":
        jsx = <ContentText {...fields[i].compProps} />
        break;
      case "categoryIds":
        jsx = <WizClassifySelectRe {...fields[i].compProps} />
        break;
      case "authCmd":
        //jsx = <WizAuthority {...fields[i].compProps} />
        jsx = <WizDataAuthSelect {...fields[i].compProps} />         
        break;
      case "selectMul":
        jsx = <WizTableForm {...WizTableForm.Config.label(this, { apiParams: { type: 6 } })} {...fields[i].compProps} onChangeRowMap={onChangeRowMap} needSelect={false} />
        break;
      default:
        let maxLength = undefined;
        if (fields[i].name === 'title') {
          maxLength = 50
          if(hiddenType === 'learningMaterials') {
            maxLength = 20
          }
        } else if(fields[i].name === "author") {
          maxLength = 10
        }

        jsx = <WizInput placeholder={!maxLength ? `请输入${fields[i].label}` : `请输入${fields[i].label},最多输入${maxLength}个字`} maxLength={maxLength} />;
        break;
    }

    formFieldOptions = {
      initialValue: fields[i].initialValue,
      ...other
    }

    item = (
      <WizAntdForm.Item
        key={i}
        label={fields[i].label}
        labelCol={fields[i].labelCol || formItemLayout.labelCol}
        wrapperCol={fields[i].wrapperCol || formItemLayout.wrapperCol}
      >
        {getFieldDecorator(
          fields[i].name,
          fields[i].required ? { ...formFieldOptions, ...config(fields[i]) } : { ...formFieldOptions }
        )(jsx)}
        {fields[i].tip && (
          <span style={{ color: "#ccc" }}>{fields[i].tip}</span>
        )}
      </WizAntdForm.Item>
    );

    if (withCol === true) {
      children.push(<WizCol key={i} span={colSpan}>{item}</WizCol>);
    } else {
      children.push(item);
    }
  }
  return withCol === true ? (
    children
  ) : (
      <WizRow>
        <WizCol span={colSpan}>{children}</WizCol>
      </WizRow>
    );
};

function AvatarUpload(props) {
  const { onChange } = props
  const handleChange = (files) => {
    onChange && onChange(files[0].fileId)
  }
  const _props = {
    onChange: handleChange,
    aspectRatio: 400/207,
    accept: ".jpg, .jpeg, .png",
    listType: "picture-card",
    beforeUpload: (file) => {
      Wizmessage.destroy()
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isLt1M) {
        Wizmessage.error('图片不得超过1MB!');
      }
      return isLt1M;
    },
    ...props
  }
  return <WizAvatarUpload {..._props} />
}
